<template>
  <transition>
    <aside v-show="value" class="paper-background">
      <Scribbles />
      <template v-if="Exhibitions && SpecialProjects">
        <div class="w-100 menu-content py-16 py-lg-16">
          <v-row align="center" justify="start">
            <v-col class="col-12 col-md-6">

              <div class="d-flex flex-column px-4">
                <InteractiveLabel v-for="(exhib, i) in Exhibitions.items"
                  :key="exhib.id"
                  :label="exhib.title"
                  :name="exhib.isVideoExhibition ? RouteNames.VIDEO_EXHIBITION.name : RouteNames.PHOTO_EXHIBITION.name"
                  :params="{slug: exhib._slug}"
                  :index="i + 1"
                  :active="!isOver || isOver && selectedIndex === (i + 1)"
                  @mouseenter.native="isOver = true; selectedIndex = (i + 1)"
                  @mouseleave.native="isOver = false; selectedIndex = -1"
                />
              </div>

            </v-col>

          </v-row>
          <v-row align="center" justify="end">
            <v-col class="d-flex flex-column col-12 col-md-6">

              <div class="d-flex flex-column px-4 right">

                <InteractiveLabel v-for="(item, i) in SpecialProjects.items"
                  :key="item.id"
                  :label="item.title"
                  :labelOver="item.sponsorName"
                  :name="RouteNames.SPECIAL_PROJECT.name"
                  :params="{type: item.type, slug: item._slug}"
                  :index="Exhibitions.items.length + i + 1"
                  small
                  :active="!isOver || isOver && selectedIndex === (Exhibitions.items.length + i + 1)"
                  @mouseenter.native="isOver = true; selectedIndex = (Exhibitions.items.length + i + 1)"
                  @mouseleave.native="isOver = false; selectedIndex = -1"
                />

                <InteractiveLabel
                  label="The Talks"
                  :name="RouteNames.PROGRAM.name"
                  :index="SpecialProjects.items.length + Exhibitions.items.length + 1"
                  small
                  :active="!isOver || isOver && selectedIndex === (SpecialProjects.items.length + Exhibitions.items.length + 1)"
                  @mouseenter.native="isOver = true; selectedIndex = (SpecialProjects.items.length + Exhibitions.items.length + 1)"
                  @mouseleave.native="isOver = false; selectedIndex = -1"
                  />

                <!-- <InteractiveLabel
                  label="Special Projects"
                  :name="RouteNames.SPECIAL_PROJECTS.name"
                  :index="6"
                  small
                  @mouseenter.native="isOver = true"
                  @mouseleave.native="isOver = false"
                  /> -->

                <InteractiveLabel
                  label="All you need to know"
                  href="https://www.vogue.it/fotografia/article/all-you-need-to-know-about-photo-vogue-festival-2020"
                  :index="SpecialProjects.items.length + Exhibitions.items.length + 2"
                  small
                  :active="!isOver || isOver && selectedIndex === (SpecialProjects.items.length + Exhibitions.items.length + 2)"
                  @mouseenter.native="isOver = true; selectedIndex = (SpecialProjects.items.length + Exhibitions.items.length + 2)"
                  @mouseleave.native="isOver = false; selectedIndex = -1"
                  />

              </div>

            </v-col>

          </v-row>
        </div>
      </template>
      <v-btn class="bottom-left-btn text-script" :small="!$vuetify.breakpoint.xs" :x-small="$vuetify.breakpoint.xs" text :to="{name: RouteNames.ABOUT.name}" data-cursor-target="asterisk|center center">Thanks to</v-btn>
      <!-- <v-btn class="bottom-center-btn text-script red--text" text :small="!$vuetify.breakpoint.xs" :x-small="$vuetify.breakpoint.xs" :to="{name: RouteNames.PROGRAM.name}" data-cursor-target="calendar|center center">The Talks</v-btn> -->
    </aside>
  </transition>
</template>

<script>
// eslint-disable-next-line
import gsap from 'gsap'
import ListExhibition from '@/graphql/ListExhibition.gql'
import ListSpecialProject from '@/graphql/ListSpecialProject.gql'
import InteractiveLabel from '@/atoms/InteractiveLabel'
import { Viewport } from '@monogrid/vue-lib'
import Scribbles from '@/molecules/Scribbles'
// import ClipMask from '@/molecules/ClipMask'

export default {
  name: 'MainMenu',
  mixins: [Viewport],
  data () {
    return {
      isOver: false,
      activeIndex: -1,
      selectedIndex: -1
    }
  },
  components: {
    InteractiveLabel,
    Scribbles
  },
  props: {
    value: {
      required: true
    }
  },

  apollo: {
    Exhibitions: {
      query: ListExhibition,
      variables () {
        return {
          status: 'PUBLISHED',
          sortOn: 'priority',
          descending: true
        }
      }
    },
    SpecialProjects: {
      query: ListSpecialProject,
      variables () {
        return {
          status: 'PUBLISHED',
          sortOn: 'priority',
          descending: false
        }
      }
    }
  },

  watch: {
    $route (value) {
      this.$emit('input', false)
    },
    activeIndex () {
      console.log(this.activeIndex)
    }
  },

  methods: {
    getRandomInt (min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      return Math.floor(Math.random() * (max - min + 1)) + min
    }
  }
}
</script>

<style lang="scss" scoped>

aside {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  transform-origin: 50% 50%;
  z-index: $z-menu !important;
  // overflow-y: auto;
  // overflow-x: hidden;
  // -webkit-overflow-scrolling: touch;
  background-color: map-get($shades, 'white');
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .menu-content {
    width: 100%;
    position: relative;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .row {
    flex: none;
    max-width: 1280px;
    margin: 0 auto;
    width: 100%;
  }

  .right {
    position: relative;

    @include breakpoint(md-and-up) {
      transform: translateY(-40px);
    }
  }
}

</style>
